import {gql} from '@apollo/client'

export const STREAM_DETAIL = gql`
  fragment StreamDetail on Stream {
    id
    name
    created
    updated
    environmentId
    isMandatory
    containers: streamContainersByEnvironmentIdAndStreamId(
      filter: {enabled: {equalTo: true}}
    ) {
      totalCount
    }
    triggerEvents: activeTriggers {
      totalCount
    }
  }
`

export const STREAM_LIST = gql`
  query StreamList(
    $environmentId: String!
    $orderBy: [StreamsOrderBy!]! = [UPDATED_DESC]
  ) {
    streams(
      orderBy: $orderBy
      condition: {environmentId: $environmentId, deleted: false}
    ) {
      nodes {
        ...StreamDetail
      }
      totalCount
    }
  }
  ${STREAM_DETAIL}
`

export const GET_STREAM = gql`
  query GetStream($id: String!, $environmentId: String!) {
    stream(id: $id, environmentId: $environmentId) {
      ...StreamDetail
    }
  }
  ${STREAM_DETAIL}
`

export const ADD_STREAM = gql`
  mutation AddStream($environmentId: String!, $name: String!) {
    createStream(
      input: {stream: {name: $name, environmentId: $environmentId}}
    ) {
      stream {
        ...StreamDetail
      }
    }
  }
  ${STREAM_DETAIL}
`

export const EDIT_STREAM = gql`
  mutation EditStream($id: String!, $environmentId: String!, $name: String!) {
    updateStream(
      input: {id: $id, environmentId: $environmentId, patch: {name: $name}}
    ) {
      stream {
        ...StreamDetail
      }
    }
  }
  ${STREAM_DETAIL}
`

export const DELETE_STREAM = gql`
  mutation DeleteStream($id: String!, $environmentId: String!) {
    updateStream(
      input: {id: $id, environmentId: $environmentId, patch: {deleted: true}}
    ) {
      stream {
        ...StreamDetail
      }
    }
  }
  ${STREAM_DETAIL}
`

type StreamLike = {
  name: string
  isMandatory: boolean
}

export const sortMandatoryThenAlpha = (s1: StreamLike, s2: StreamLike) =>
  s1.isMandatory
    ? -1
    : s2.isMandatory
    ? 1
    : s1.name.toLowerCase().localeCompare(s2.name.toLowerCase())

export const createStreamOption = (s: Stream) => ({
  value: s.id,
  text: s.name,
  // always include the mandatory streams
  mandatory: s.isMandatory
})

export type Stream = {
  id: string
  name: string
  isMandatory: boolean
  /** UI only - useful when a stream should be initially selected
   * in a given context e.g. Delivery settings for test sends */
  shouldBeCheckedInitially?: boolean
}
